import { combineReducers } from "redux"
import socket from "./socket"

const socketReducer = combineReducers({
  socket
})

export default socketReducer